
import './App.css';
import  Images from './components/Images'
function App() {
  return (
    <div className="App">
        <header>
          <h1>#EndSars Archive Gallery</h1>
          <h3 className="creator">Created by <a href="https://twitter.com/OLU_WASEYI">@OLU_WASEYI</a></h3>
      </header>
      <Images/>
    </div>
  );
}

export default App;
